import { appName, targetEnv } from '@fs/zion-config'

const hasWindow = typeof window !== 'undefined'

// Helper function to check if URL is a FamilySearch domain
export function isFSDomain(url) {
  if (!url) return false

  // relative URLs should match the app domain and therefore are valid
  if (url.startsWith('/') && !url.startsWith('//')) return true

  // protocol-relative URLs are not considered FamilySearch domains
  if (url.startsWith('//')) return false

  try {
    const hostname = new URL(url).hostname
    // localhost URLs we will assume are valid
    if (hostname === 'localhost') return true

    return (
      hostname.endsWith('.familysearch.org') ||
      hostname === 'familysearch.org' ||
      hostname.endsWith('.researchllm.org') ||
      hostname === 'researchllm.org' ||
      hostname.endsWith('.fslocal.org') ||
      hostname === 'fslocal.org'
    )
  } catch {
    // If URL parsing fails, assume it's not a FamilySearch domain
    return false
  }
}

// Add FS-User-Agent-Chain header for FamilySearch domains
//
// Mimicking user-agent docs for variable names used here
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/User-Agent#comment
export const userAgentChainInterceptor = (config) => {
  if (isFSDomain(config.url)) {
    const product = `${appName}-${targetEnv}`
    const comment = constructUserAgentComment(config.fsUserAgentChainSuffix)

    config.headers = config.headers || {}
    config.headers['FS-User-Agent-Chain'] = `${product}${comment}`
  }
  return config
}

/**
 * builds a string of a user-agent comment
 *
 * @returns string
 * no variables exist: ""
 * 1 of the variables exist: " (theVariable)"
 * both variables exist: " (locationPath; suffix)"
 */
function constructUserAgentComment(suffix = '') {
  const locationPath = hasWindow ? window.location.pathname : ''

  if (locationPath && suffix) {
    return ` (${locationPath}; ${suffix})`
  }

  if (locationPath) {
    return ` (${locationPath})`
  }

  if (suffix) {
    return ` (${suffix})`
  }

  return ''
}
